export default __webpack_public_path__ + "static/media/kandolab-logo_v1.f0005554.png";